import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { validate as validateGuid } from 'uuid';

export const GuidGuard = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    let isValidGuid = false;

    if (Object.keys(route.queryParams).includes('guid')) {
        isValidGuid = validateGuid(route.queryParams.guid);
    }
    const noGuidUrl = router.parseUrl('actions');

    return isValidGuid || noGuidUrl;
};
